import { Link } from 'react-router-dom';

export default function BrandStatement() {
  return (
    <section className="py-32 px-8 bg-[#151515]">
      <div className="max-w-[1600px] mx-auto">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          {/* Left - Text Content */}
          <div className="md:col-span-3 space-y-8">
            <p className="text-sm font-bold tracking-[0.15em] uppercase bg-gradient-to-r from-white via-gray-300 to-white bg-clip-text text-transparent">
              EST. 2017 • KALAMAZOO, MI
            </p>
            
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight">
              More Than Clothing.<br />
              A Movement.
            </h2>
            
            <p className="text-lg text-gray-300 leading-relaxed max-w-2xl">
              BillPlay Apparel was built from the Northside with a mission to represent culture, confidence, and unity. From ages 5 to 70, we create for every generation that moves with purpose. Rooted in authenticity. Driven by hustle. Expanding nationwide while staying true to the streets that raised us.
            </p>
            
            <Link 
              to="/story" 
              className="inline-block border-2 border-white text-white px-8 py-4 rounded-lg font-bold text-sm tracking-wide hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap"
            >
              READ OUR STORY
            </Link>
          </div>

          {/* Right - Image */}
          <div className="md:col-span-2">
            <div className="relative h-[500px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/cdf3bd8e205e7b576f6b09451de39848.jpg"
                alt="Northside Kalamazoo"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-black/30 via-transparent to-black/50"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}